import $ from 'jquery';
import Headroom from 'headroom.js';

window.jQuery = $;
window.Headroom = Headroom;
